import { LicenseAttribution } from '@connect-x-app/shared-domain-models';

import licenses from '../generated/licenses.json';
import metadata from '../generated/metadata.json';

const isLicenseAttributionList = (value: unknown): value is LicenseAttribution[] => Array.isArray(value);

export type LicenseAttributionMetadata = {
  generatedAt: string;
  revision: string;
};

export const LICENSE_ATTRIBUTION_METADATA: LicenseAttributionMetadata = metadata;

export const LICENSE_ATTRIBUTION: LicenseAttribution[] = isLicenseAttributionList(licenses) ? licenses : [];

export const licenseAttributionKey = ({ group, licenseId, name, url, version }: LicenseAttribution): string =>
  JSON.stringify([group ?? '', name, version ?? '', licenseId ?? '', url ?? '']);

export const licenseAttributionTitle = ({ group, name, version }: LicenseAttribution): string => {
  const qualifiedName = group ? `${group}/${name}` : name;
  return version ? `${qualifiedName}@${version}` : qualifiedName;
};
